export const routes = {
  name: 'SiteMap',
  title: 'Plan du site',
  path: () => '/plan-du-site'
} as const
